<ng-container *ngIf="filterOptions.length; else noSupportedOperators">
  <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="center center">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Operation</mat-label>
      <mat-select [(ngModel)]="newValue.operation">
        <mat-select-trigger>
          {{ newValue.operation ? newValue.operation.type : '' }}
        </mat-select-trigger>
        <mat-option *ngFor="let option of filterOptions" [value]="option" [disabled]="!enabledOptions[option.type]">{{
          option?.label
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Value</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="newValue.value" placeholder="Value" />
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error>Please use a valid date in the format <strong>YYYY-MM-DD</strong></mat-error>
    </mat-form-field>

    <button
      mat-mini-fab
      class="add-filter-button"
      color="accent"
      [disabled]="!newValue.operation || newValue.value === null || newValue.value === undefined"
      (click)="handleAdd(newValue)"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <rds-c-chips
    [chips]="filters | rdsDateFiltersToChips"
    [dense]="false"
    [removable]="true"
    (removed)="handleRemove($event)"
    [vertical]="true"
  ></rds-c-chips>
</ng-container>
<ng-template #noSupportedOperators>
  <p>No filter operations are supported for this data product.</p>
</ng-template>
